import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './Loader.module.scss';

const Loader = ({ color = '' }) => {
    const classes = classNames(styles['Loader'], {
        [styles[`Loader--${color}`]]: color,
    });
    return <div className={classes} />;
};

Loader.propTypes = {
    color: PropTypes.string,
};

export default Loader;
